import { WidgetPropertyKeys, OneOfElementPropertyKeys } from '../domain';
import { IColor } from './color';
import { IFontStyle } from './font';
import { IFeed, IFeedData } from './feed';
import { IElementNode, NodeKind, IElementDataNode } from './nodes';
import { Widget } from '../widget/widget';
import { IAsset } from './asset';

export interface ILibraryWidget {
    id?: string;
    name: string;
    thumbnailUrl?: string;
    comment: string;

    // Should be WidgetProperty[] extends ElementProperties
    properties: IWidgetElementProperty[];
    exportable: boolean;
    state?: LibraryWidgetState;
    versionId?: number;
    imported?: boolean;
}

export interface IWidgetElementDataNode extends IElementDataNode<NodeKind.Widget> {
    html: string;
    js: string;
    ts: string;
    css: string;
    customProperties?: IWidgetCustomProperty[];
    parentId?: string;
    widgetReference?: string;
    __widget?: Widget;
}

export type WidgetProperties = keyof IWidgetElementDataNode;


export interface IWidgetElement extends IElementNode<NodeKind.Widget> {
    widgetAsset: IWidgetLibraryAsset;
    html: string;
    js: string;
    css: string;
    customProperties?: IWidgetCustomProperty[];
    parentId?: string;
}

export interface IWidgetLibraryAsset {
    thumbnail: string;
    bannerflowLibraryId: string;
}

// New interface
export interface IWidgetElementProperty {
    name: OneOfElementPropertyKeys | WidgetPropertyKeys | string;
    label?: string;
    value?: OneOfCustomPropertyValue;
    unit?: WidgetUnits;

    versionPropertyId?: string;
}

export interface IWidgetImage extends Omit<Partial<IAsset>, 'width' | 'height'> {}

export type OneOfCustomPropertyValue =
    string |
    number |
    boolean |
    IWidgetSelectOption[] |
    IColor |
    IFontStyle |
    IWidgetImage |
    IFeed;

export interface IWidgetCustomProperty {
    name: string;
    label: string;
    value?: OneOfCustomPropertyValue;
    unit: WidgetUnits;
    versionPropertyId?: string;
    clientId?: string;
}

export type WidgetCustomProperties = keyof IWidgetCustomProperty;

export enum LibraryWidgetState {
    Active = 0,
    Inactive = 1
}

export interface IWidgetSelectOption {
    value: string;
    selected: boolean;
}

export type WidgetUnits = 'number' | 'boolean' | 'select' | 'text' | 'color' | 'font' | 'feed' | 'image';

export interface IFeedHelper {
    id: string;
    /**
    * Returns a promise which resolves with FeedData
    */
    load: () => Promise<IFeedData>;
    data: {};
    loaded: boolean;
}

export const WIDGET_PROPERTY_PREFIX = 'custom:';
